import React from 'react';
import PropTypes from 'prop-types';
import withHistory from "./hocs/public-api/history/withHistory";
import SimpleChart from "./SimpleChart";

const HistoryChart = ({color, history, ...props}) => {
    if (!history) return false;

    return (
        <SimpleChart values={history} color={color}/>
    );
};

HistoryChart.propTypes = {
    serial: PropTypes.string.isRequired
};

export default withHistory()(HistoryChart);
